export function formatBRL(value, opts = {}) {
  if (value === null || value === undefined || isNaN(value)) return 'R$ —';
  const { sign = false } = opts;
  const formatted = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(value));
  if (sign) {
    if (value > 0) return `+${formatted}`;
    if (value < 0) return `-${formatted}`;
  } else if (value < 0) {
    return `-${formatted}`;
  }
  return formatted;
}

export function formatPercent(value, digits = 2) {
  if (value === null || value === undefined || isNaN(value)) return '—';
  return `${Number(value).toFixed(digits).replace('.', ',')}%`;
}

export function formatDateBR(iso) {
  if (!iso) return '—';
  try {
    const d = new Date(iso.length === 10 ? iso + 'T12:00:00' : iso);
    return d.toLocaleDateString('pt-BR');
  } catch {
    return iso;
  }
}

export function formatDateShortBR(iso) {
  if (!iso) return '—';
  try {
    const d = new Date(iso.length === 10 ? iso + 'T12:00:00' : iso);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return `${dd}/${mm}`;
  } catch {
    return iso;
  }
}

/**
 * Sort sale payments: TROCA first, then by date ascending.
 * Returns a NEW array (does not mutate).
 */
export function sortSalePayments(payments) {
  if (!Array.isArray(payments)) return [];
  return [...payments].sort((a, b) => {
    const aTrade = a.method === 'TRADE' ? 0 : 1;
    const bTrade = b.method === 'TRADE' ? 0 : 1;
    if (aTrade !== bTrade) return aTrade - bTrade;
    const ad = (a.date || '9999-12-31');
    const bd = (b.date || '9999-12-31');
    return ad.localeCompare(bd);
  });
}

export function todayISO() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export const VEHICLE_STATUS = {
  PURCHASED: { label: 'Comprado', classes: 'bg-slate-100 text-slate-700 border border-slate-200' },
  IN_PREPARATION: { label: 'Em preparação', classes: 'bg-blue-50 text-blue-700 border border-blue-200' },
  AVAILABLE: { label: 'Disponível', classes: 'bg-emerald-50 text-emerald-700 border border-emerald-200' },
  SOLD: { label: 'Vendido', classes: 'bg-[hsl(var(--success-bg))] text-[hsl(var(--success))] border border-emerald-200' },
};

export const FUEL_TYPES = {
  GASOLINE: 'Gasolina',
  ETHANOL: 'Etanol',
  FLEX: 'Flex',
  DIESEL: 'Diesel',
  ELECTRIC: 'Elétrico',
  HYBRID: 'Híbrido',
  GNV: 'GNV',
  OTHER: 'Outro',
};

export const ENTRY_TYPES = {
  DIRECT: 'Compra direta',
  TRADE: 'Troca',
  CONSIGNMENT: 'Consignação',
  AUCTION: 'Leilão',
  DEALER_TRANSFER: 'Repasse',
  OTHER: 'Outro',
};

export const PAYMENT_METHODS = {
  PIX: 'Pix',
  TED: 'TED',
  CASH: 'Dinheiro',
  CARD: 'Cartão',
  FINANCING: 'Financiamento',
  TRADE: 'Troca',
  OTHER: 'Outro',
};

export const PAYMENT_METHOD_ICONS = {
  PIX: '💸',
  TED: '🏦',
  CASH: '💵',
  CARD: '💳',
  FINANCING: '📑',
  TRADE: '🚗',
  OTHER: '➖',
};

export const EXPENSE_CATEGORIES = {
  ACQUISITION: 'Aquisição',
  DOCUMENTATION: 'Documentação',
  PREPARATION: 'Preparação',
  OPERATIONAL: 'Operacional',
  MARKETING: 'Marketing',
  SALE: 'Venda',
  OTHER: 'Outros',
};
